var _defs, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.93 27.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bcbec0;}.cls-2{fill:#f0f1f2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo_text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.9,396.8l-2.29-5.54H358l-2.38,5.54h-4.38l8.93-21.44h3.13l9,21.44H367.9ZM361.73,381l-2.29,6.5H364Z",
    transform: "translate(-351.22 -369.36)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M378.2,384.24V396.8h-3.86V384.24h-1.88v-3.51h1.88v-5.37h3.86v5.37h2.32v3.51H378.2Z",
    transform: "translate(-351.22 -369.36)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M409.87,396.8L398.6,377.2v19.6h-5v-27h5.69l11.17,19.64V369.83h5v27h-5.58Z",
    transform: "translate(-351.22 -369.36)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.42,397.28a14.09,14.09,0,0,1-14.2-14.05,13.91,13.91,0,0,1,13.87-13.87,13.73,13.73,0,0,1,12.78,8.21h-5.58a8.1,8.1,0,0,0-7.08-3.39,8.85,8.85,0,0,0-8.94,9.09,9.18,9.18,0,0,0,9.05,9.2c2.59,0,4.49-.88,6.68-3.17h5.88A13.32,13.32,0,0,1,433.42,397.28Z",
    transform: "translate(-351.22 -369.36)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.09,395.31c-2.19,1.09-4.64,1.5-8.72,1.5h-6.28v-27h6.17c4.23,0,7.45.66,9.56,1.93,3.76,2.26,5.88,6.5,5.88,11.61C470.69,388.81,468.25,393.26,464.09,395.31Zm-2.56-19.6c-1.57-.8-3.28-1.09-6.46-1.09h-1V392h1.09c3,0,5.07-.37,6.57-1.21a8.32,8.32,0,0,0,3.91-7.45C465.66,379.9,464.09,377,461.53,375.71Z",
    transform: "translate(-351.22 -369.36)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M481.83,396.8h-7.19v-27h5.55c4,0,5.69.29,7.3,1.31a6.78,6.78,0,0,1,3.07,5.88,5,5,0,0,1-3,5.07c3.43,1.42,4.6,3.47,4.6,6.68C492.16,393.7,488.76,396.8,481.83,396.8Zm-0.15-22.08h-2v5.51h1.61c3,0,4.31-.84,4.31-2.77S484.27,374.72,481.68,374.72Zm0.33,10.4h-2.37V392h2.48c3.5,0,5-1,5-3.36S485.48,385.12,482,385.12Z",
    transform: "translate(-351.22 -369.36)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/Logo_text.a23c43c9.svg";
export { ForwardRef as ReactComponent };